import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import { Provider } from "react-redux";

import store from "./store";
import { HelmetProvider } from "react-helmet-async";
import { msalInstance } from "./helpers/msalInstance";

const app = (
  <Provider store={store}>
    <HelmetProvider>
        <App instance={msalInstance} />
    </HelmetProvider>
  </Provider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(app);

serviceWorker.unregister();
